import React from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { Cross, Shield, Globe, Scroll, Crown } from '@phosphor-icons/react';

const foundingKnights = [
  'Hugues de Payens',
  'Godfried van Sint Omaars',
  'André de Montbard',
  'Gondemare',
  'Payen de Montdidier',
  'Roral',
  'Geoffroy Bisol',
  'Godefroid',
  'Archambaud de St Amancl'
];

const grandMasters = [
  { name: 'Hugues de Payens', years: '1118–1136' },
  { name: 'Robert de Craon', years: '1136–1147' },
  { name: 'Everard de Barres', years: '1147–1149' },
  { name: 'Bernard de Tremelay', years: '1149–1152' },
  { name: 'André de Montbard', years: '1152–1153' },
  { name: 'Bertrand de Blanchefort', years: '1153–1156' },
  { name: 'Philippe de Milly', years: '1156–1169' },
  { name: 'Odo de St Amand', years: '1169–1171' },
  { name: 'Arnold de Torroja', years: '1171–1179' },
  { name: 'Gerard de Ridefort', years: '1179–1184' },
  { name: 'Robert de Sablé', years: '1184–1189' },
  { name: 'Gilbert Horal', years: '1189–1193' },
  { name: 'Philippe de Plessis', years: '1193–1200' },
  { name: 'Guillaume de Chartres', years: '1201–1208' },
  { name: 'Pedro de Montaigu', years: '1209–1219' },
  { name: 'Armand de Périgord', years: '1219–1233' },
  { name: 'Richard de Bures', years: '1233–1244' },
  { name: 'Guillaume de Sonnac', years: '1244–1247' },
  { name: 'Renaud de Vichiers', years: '1247–1256' },
  { name: 'Thomas Bérard', years: '1256–1273' },
  { name: 'Guillaume de Beaujeu', years: '1273–1291' },
  { name: 'Thibaud Gaudin', years: '1291–1292' },
  { name: 'Jacques de Molay', years: '1292–1314' },
];

const successionLineage = [
  { name: 'Jean Marc Larmenius', years: '1314–1324' },
  { name: 'Theobald of Alexandria', years: '' },
  { name: 'Arnaud de Braque', years: '' },
  { name: 'Jean de Clermont', years: '' },
  { name: 'Bertrand du Guesclin', years: '' },
  { name: 'Jean III d\'Armagnac', years: '' },
  { name: 'Bernard III d\'Armagnac', years: '' },
  { name: 'Jean IV d\'Armagnac', years: '' },
  { name: 'Gaspard de Beau', years: '' },
  { name: 'Henri de Montmorency', years: '' },
  { name: 'Charles de Valois', years: '' },
  { name: 'Jacques Rouault', years: '' },
  { name: 'Jacques Henri Durfort', years: '' },
  { name: 'Philippe de Bourbon', years: '' },
  { name: 'Louis Auguste de Bourbon', years: '' },
  { name: 'Louis Henri de Bourbon', years: '' },
  { name: 'Louis François de Bourbon', years: '' },
  { name: 'Louis Hercule de Rohan', years: '' },
  { name: 'Claude Mathieu Radix de Chevillon', years: '1792–1804' },
  { name: 'Bernard Raymond Fabré Palaprat', years: '1804' },
];

const modernLineage = [
  { name: 'Joseph VanDerberg', years: '1932' },
  { name: 'Émile Clément Joseph Isaac Vandenberg', years: '1935' },
  { name: 'Don Antonio Campello Pinto de Sousa Fontes', years: '1939–1942' },
  { name: 'Re-registration at Namur, Belgium', years: '1957' },
];

const AboutPage = () => {
  return (
    <PublicLayout>
      {/* Header */}
      <section className="py-20 bg-[#1A1614] text-center" data-testid="about-header">
        <p className="text-overline mb-4">About the Order</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-white mb-4">
          Grand Priory of the Caribbean
        </h1>
        <p className="text-[#8A847A] max-w-2xl mx-auto px-4">
          SCMOTH 1804 OSMTJ - Sovereign Military Order of the Temple of Jerusalem
        </p>
      </section>

      {/* Quick Stats */}
      <section className="py-16 bg-white" data-testid="about-stats">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#7B1818]/10 text-[#7B1818]">
                <Scroll size={32} weight="regular" />
              </div>
              <h3 className="font-heading text-xl mb-2">Origins</h3>
              <p className="text-2xl font-heading text-[#7B1818]">1118</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#7B1818]/10 text-[#7B1818]">
                <Cross size={32} weight="regular" />
              </div>
              <h3 className="font-heading text-xl mb-2">Restored</h3>
              <p className="text-2xl font-heading text-[#7B1818]">1804</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#7B1818]/10 text-[#7B1818]">
                <Globe size={32} weight="regular" />
              </div>
              <h3 className="font-heading text-xl mb-2">Jurisdiction</h3>
              <p className="text-[#4A453E]">Caribbean Region</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#7B1818]/10 text-[#7B1818]">
                <Shield size={32} weight="regular" />
              </div>
              <h3 className="font-heading text-xl mb-2">Constituted</h3>
              <p className="text-2xl font-heading text-[#7B1818]">2024</p>
            </div>
          </div>
        </div>
      </section>

      {/* History of the Knights Templar */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="about-history">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-heading text-3xl text-[#1A1614] mb-6 text-center">History of the Knights Templar</h2>
            
            <h3 className="font-heading text-2xl text-[#1A1614] mb-4 mt-8">The Founding in Jerusalem</h3>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              In the year 1118, following the success of the First Crusade and the establishment of the 
              Kingdom of Jerusalem, nine French knights led by Hugues de Payens presented themselves to 
              King Baldwin II with a sacred purpose: to protect Christian pilgrims traveling to the Holy Land. 
              The King granted them quarters in the Al-Aqsa Mosque on the Temple Mount, the site believed to 
              be the ruins of the Temple of Solomon. From this location, they took their name—the Poor 
              Fellow-Soldiers of Christ and of the Temple of Solomon, known to history as the Knights Templar.
            </p>

            <h3 className="font-heading text-2xl text-[#1A1614] mb-4 mt-8">Papal Recognition: Omne Datum Optimum</h3>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              The Order received formal ecclesiastical recognition at the Council of Troyes in 1129, where 
              Saint Bernard of Clairvaux championed their cause and helped draft their rule. However, it was 
              the papal bull <em>Omne Datum Optimum</em>, issued by Pope Innocent II on March 29, 1139, that 
              transformed the Templars into one of the most powerful institutions in Christendom.
            </p>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              This landmark bull granted the Order extraordinary privileges: exemption from local laws and 
              taxes, freedom from the authority of local bishops, and the right to answer only to the Pope 
              himself. The Templars could build their own oratories, collect tithes, and bury their dead in 
              their own cemeteries. These privileges allowed the Order to operate across borders as a truly 
              international institution.
            </p>

            <h3 className="font-heading text-2xl text-[#1A1614] mb-4 mt-8">Growth and Influence</h3>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              Over the following two centuries, the Knights Templar grew into a formidable military, financial, 
              and diplomatic force. They established commanderies throughout Europe and the Holy Land, developed 
              innovative banking practices that allowed pilgrims to deposit funds in Europe and withdraw them 
              in Jerusalem, and became trusted advisors to kings and popes alike. Their distinctive white 
              mantles bearing the red cross became symbols of Christian valor throughout the medieval world.
            </p>

            <h3 className="font-heading text-2xl text-[#1A1614] mb-4 mt-8">The Restoration of 1804</h3>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              In 1804, Bernard Raymond Fabré Palaprat, a physician from the south of France, publicly 
              restored the Order in Paris. The restoration occurred during the reign of Napoleon Bonaparte, 
              whose government provided official recognition to the revived Order. Napoleon, who had a 
              documented interest in chivalric traditions and the legacy of the Crusades, saw value in 
              the restoration of this ancient institution.
            </p>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              Under Fabré Palaprat's leadership, the Order was reorganized and its ceremonies were 
              publicly celebrated, including a notable Mass at the Church of Saint-Paul-Saint-Louis 
              in Paris. The restoration brought the Templar tradition back into public life after 
              centuries, establishing the foundation for the modern Order that continues today.
            </p>

            <h3 className="font-heading text-2xl text-[#1A1614] mb-4 mt-8">The Grand Priory of the Caribbean</h3>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              In 2024, the Grand Priory of the Caribbean was formally constituted under the authority of 
              the Grand Magisterium, establishing our jurisdiction across the Caribbean region. We continue 
              the sacred mission that began with nine knights in Jerusalem over nine centuries ago.
            </p>
          </div>
        </div>
      </section>

      {/* Our Lineage */}
      <section className="py-16 bg-white" data-testid="about-lineage-intro">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center">
            <h2 className="font-heading text-3xl text-[#1A1614] mb-6">Our Lineage</h2>
            <p className="text-[#4A453E] leading-relaxed max-w-2xl mx-auto">
              The Grand Priory of the Caribbean traces its lineage through an unbroken succession 
              from the founding of the Knights Templar in 1118, through the restoration of 1804, 
              to our constitution in 2024 under the Grand Magisterium.
            </p>
          </div>
        </div>
      </section>

      {/* Founding Knights */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="founding-knights">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-overline mb-4">Anno Domini 1118</p>
            <h2 className="font-heading text-3xl text-[#1A1614] mb-4">The Nine Founding Knights</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {foundingKnights.map((knight, index) => (
              <div key={index} className="bg-white border border-[#D8D2C4] p-4 text-center">
                <p className="font-heading text-lg text-[#1A1614]">{knight}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Grand Masters */}
      <section className="py-16 bg-[#1A1614]" data-testid="grand-masters">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-overline mb-4">1118 – 1314</p>
            <h2 className="font-heading text-3xl text-white mb-4">Grand Masters</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {grandMasters.map((master, index) => (
              <div key={index} className="bg-[#2A2420] border border-[#3A3430] p-4">
                <p className="font-heading text-white">{master.name}</p>
                <p className="text-[#8A847A] text-sm">{master.years}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Succession 1314-1804 */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="succession">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-overline mb-4">1314 – 1804</p>
            <h2 className="font-heading text-3xl text-[#1A1614] mb-4">Succession</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {successionLineage.map((leader, index) => (
              <div key={index} className="bg-white border border-[#D8D2C4] p-4">
                <p className="font-heading text-[#1A1614]">{leader.name}</p>
                {leader.years && <p className="text-[#7B1818] text-sm">{leader.years}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modern Era */}
      <section className="py-16 bg-white" data-testid="modern-era">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-overline mb-4">1932 – Present</p>
            <h2 className="font-heading text-3xl text-[#1A1614] mb-4">Modern Era</h2>
          </div>
          <div className="max-w-2xl mx-auto">
            {modernLineage.map((leader, index) => (
              <div key={index} className="flex items-center gap-4 mb-4 p-4 bg-[#F5F2EB] border border-[#D8D2C4]">
                <div className="w-12 h-12 flex items-center justify-center bg-[#7B1818] text-white flex-shrink-0">
                  <Crown size={24} weight="regular" />
                </div>
                <div>
                  <p className="font-heading text-[#1A1614]">{leader.name}</p>
                  {leader.years && <p className="text-[#7B1818] text-sm">{leader.years}</p>}
                </div>
              </div>
            ))}
            <div className="mt-8 p-6 bg-[#7B1818] text-white text-center">
              <p className="text-overline text-white/70 mb-2">Constituted 2024</p>
              <p className="font-heading text-2xl">Grand Priory of the Caribbean</p>
              <p className="text-white/80 mt-2">Under the Grand Magisterium</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Purpose */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="about-purpose">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-heading text-3xl text-[#1A1614] mb-6">Our Purpose</h2>
            <p className="text-[#4A453E] leading-relaxed mb-6">
              The Grand Priory exists to preserve and promote the ideals of Christian chivalry. 
              Our members are dedicated to:
            </p>
            <ul className="list-disc list-inside text-[#4A453E] space-y-2 mb-6">
              <li>Upholding the Christian faith and its values</li>
              <li>Supporting charitable causes throughout the Caribbean</li>
              <li>Promoting leadership and integrity in public life</li>
              <li>Preserving the history and traditions of the Knights Templar</li>
              <li>Fostering brotherhood among members</li>
            </ul>

            <h2 className="font-heading text-3xl text-[#1A1614] mb-6 mt-12">The Templar Cross</h2>
            <p className="text-[#4A453E] leading-relaxed">
              The red cross pattée is the symbol of our Order, representing the sacrifice of Christ 
              and the dedication of the original Knights Templar to the defense of the faith. 
              This emblem, worn by our members, signifies their commitment to the ideals of 
              Christian chivalry and service.
            </p>
          </div>
        </div>
      </section>

      {/* Motto */}
      <section className="py-16 bg-[#1A1614]" data-testid="about-motto">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-overline text-[#C9A54E] mb-4">Our Motto</p>
          <h2 className="font-heading text-4xl text-white mb-4">Non Nobis Domine</h2>
          <p className="text-xl text-[#8A847A] italic mb-8">
            "Not unto us, O Lord, not unto us, but unto Thy name give glory"
          </p>
          <p className="text-[#8A847A] max-w-2xl mx-auto">
            This ancient motto of the Knights Templar reminds us that our service is not for 
            personal glory, but for the greater good and in service to a higher purpose.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
};

export default AboutPage;
